/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-modular.vue?vue&type=template&id=1d4f5322&scoped=true&"
import script from "./batch-modular.vue?vue&type=script&lang=ts&"
export * from "./batch-modular.vue?vue&type=script&lang=ts&"
import style0 from "./batch-modular.vue?vue&type=style&index=0&id=1d4f5322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f5322",
  null
  
)

export default component.exports